import { SELECT_AND_LINK_PARAM } from '../SelectAndLink.constants'
import { SelectAndLinkSession } from '../SelectAndLink.types'

export function buildSelectAndLinkIframeUrl(
  session: SelectAndLinkSession
): string {
  const targetSitemodel =
    session.targetPath || window.selectAndLinkFilterSitemodel
  const url = window.origin + `/${targetSitemodel}`
  const parsedUrl = new URL(url)
  const optionsForUrl = session.urlSelectedOptions ?? session.selectedOptions

  const searchParams = new URLSearchParams(parsedUrl.search)

  searchParams.set('uuid_objectclass', session.objectclassUuid)
  searchParams.set(SELECT_AND_LINK_PARAM, '')

  if (optionsForUrl?.length) {
    searchParams.set('selected_objects', JSON.stringify(optionsForUrl))
  }

  return `${parsedUrl.origin}${parsedUrl.pathname}?${searchParams.toString()}`
}
